import React from 'react';
import { useNotifications } from '../hooks/useNotifications';
import './NotificationSettings.css';

export default function NotificationSettings() {
  const { isSupported, permission, hasPermission, requestPermission, playSound } = useNotifications();

  if (!isSupported) {
    return (
      <div className="notification-settings">
        <div className="alert alert-warning">
          <strong>Notifications not supported</strong>
          <p>Your browser doesn't support push notifications.</p>
        </div>
      </div>
    );
  }

  const getPermissionStatus = () => {
    switch (permission) {
      case 'granted':
        return { text: 'Enabled', class: 'text-success' };
      case 'denied':
        return { text: 'Blocked', class: 'text-danger' };
      default:
        return { text: 'Not requested', class: 'text-warning' };
    }
  };

  const status = getPermissionStatus();

  return (
    <div className="notification-settings">
      <div className="card">
        <div className="card-body">
          <h5 className="card-title">Notification Settings</h5>
          
          <div className="mb-3">
            <div className="d-flex justify-content-between align-items-center">
              <div>
                <strong>Push Notifications:</strong>
                <span className={`ms-2 ${status.class}`}>{status.text}</span>
              </div>
              <div className="btn-group">
                {!hasPermission && permission !== 'denied' && (
                  <button 
                    className="btn btn-primary btn-sm"
                    onClick={requestPermission}
                  >
                    Enable Notifications
                  </button>
                )}
                {hasPermission && (
                  <button 
                    className="btn btn-outline-secondary btn-sm"
                    onClick={playSound}
                  >
                    Test Sound
                  </button>
                )}
              </div>
            </div>
          </div>

          {permission === 'denied' && (
            <div className="alert alert-info">
              <strong>Notifications are blocked</strong>
              <p className="mb-0">
                To enable notifications, click the lock icon in your browser's address bar and allow notifications for this site.
              </p>
            </div>
          )}

          {hasPermission && (
            <div className="alert alert-success">
              <strong>Notifications enabled!</strong>
              <p className="mb-0">
                You'll receive push notifications and sound alerts when new quote requests arrive or existing ones are updated.
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}